import Rails from '@rails/ujs'
import './alpine'
import '../controllers/fire'
import '../css/fire.scss'
import '@fortawesome/fontawesome-free/css/all.css'

require.context('../assets/', true, /\.(svg|jpg|png)$/)
Rails.start()
